import React from 'react';
import util from "../../../util/tools";
import commonTools from "../../../../common/util/util";
import P from "prop-types";
import Img from "react-image";
import './index.css';

export default class Home extends React.Component {
    static propTypes = {
        location: P.any,
        history: P.any,
        actions: P.any
    };

    constructor(props) {
        super(props);
        this.state = {
            timer:false,
            curTitle: "免费趣小说",
            money: 0,
            code: "",
            ewmImgUrl: require("../../../images/ewmBg.png") || ""
        };
        this.goFun = this.goFun.bind(this);
        this.getMoney = this.getMoney.bind(this);
    }

    componentDidMount() {
        document.title = this.state.curTitle;

        try{
            localStorage.setItem("turl",document.location.href);
        }catch(e){}

        this.getMoney();

        util.ajax({
            url: "/zh/attentionuser/QRCodeUrl",
            method:'post',
            data: {},
            callback: res => {
                if (res.result.status.code == 0) {
                    this.setState({
                        ewmImgUrl: res.result.data.url
                    });
                }
            }
        });
    }

    getMoney(){
        util.ajax({
            host: "//open.kxxsc.com",
            app_key: "6529624231",
            app_secret: "aedddf6bc6c4aba9d317efb843d6eb29",
            app_token: 1,
            url: "/app/quxiaoshuo/share/request_red_packet",
            data: {
                sn: commonTools.searchPar().sn,
                user_id: commonTools.searchPar().user_id,
                app_id: commonTools.searchPar().app_id,
                open_id: util.open_id,
            },
            callback: res => {
                if (res.result.status.code == 0) {
                    let json = res.result.data;
                    this.setState({
                        money: json.amount/100,
                    });
                }else{
                    alert(res.result.status.msg);
                }
            }
        });
    }

    goFun(){
        if(!this.state.code){
            return false;
        }
        let phoneNum = this.inputRef.value;
        if(phoneNum.length != 11){
            alert("请正确填写十一位手机号");
            return false;
        }

        util.ajax({
            host: "//open.kxxsc.com",
            app_key: "6529624231",
            app_secret: "aedddf6bc6c4aba9d317efb843d6eb29",
            app_token: 1,
            url: "/app/quxiaoshuo/share/receive_red_packet",
            data: {
                code: this.state.code,
                user_id: commonTools.searchPar().user_id,
                app_id: commonTools.searchPar().app_id,
                open_id: util.open_id,
                mobile: phoneNum
            },
            callback: res => {
                if (res.result.status.code == 0) {
                    try{
                        window.bridge.jump(`client://kanshu/receive_money?phone=${phoneNum}&share_type=${commonTools.searchPar().share_type}&user_id=${commonTools.searchPar().user_id}`);
                    }catch(e){
                        document.location.href = `//activity.read2.cn/quxiaoshuo/down?phone=${phoneNum}&share_type=${commonTools.searchPar().share_type}&user_id=${commonTools.searchPar().user_id}`;
                        // this.props.history.push(`/quxiaoshuo/down?phone=${phoneNum}&share_type=${commonTools.searchPar().share_type}&user_id=${commonTools.searchPar().user_id}`);
                    }
                }else{
                    alert(res.result.status.msg);
                }
            }
        });
    }

    render() {
        return (
            <div className='quxiaoshuoHome'>
                <div className='title1'>看免费小说，领现金工资</div>
                <div className='title2'>恭喜你获得</div>
                <div className='money'>{this.state.money}元</div>
                <div className="ewmBox">
                    <Img className="ewmBg" src={require("../../../images/ewmBg.png")} />
                    {!!this.state.ewmImgUrl && <Img className="ewmImg" src={this.state.ewmImgUrl} />}
                </div>
                <input type="number" className="inputTxt" ref={node=>this.inputRef=node} placeholder="请输入手机号" />
                <div className='getBtn' onClick={this.goFun}>马上领取现金红包</div>
            </div>
        );
    }
}